import styles from "./styles.module.scss";

export const ImageTextGrid = ({ title, items = [], className = "" }) => {
  return (
    <section className={`${styles.root} ${className}`}>
      {title && (
        <h2 className={styles.title} data-sourceflow-prop="title">
          {title}
        </h2>
      )}
      <div className={styles.grid}>
        {items.map(({ image, text, link, backgroundColor }, index) => {
          const inlineStyle = image?.url
            ? { backgroundImage: `url(${image.url})` }
            : {};

          const cardClassName = `${styles.card}${
            backgroundColor ? ` ${backgroundColor}` : ""
          }`;

          return (
            <a
              key={index}
              href={link || "#"}
              className={cardClassName}
              data-sourceflow-prop="items"
              style={inlineStyle}
            >
              <div
                className={styles.text}
                data-sourceflow-prop={`items.${index}.text`}
                dangerouslySetInnerHTML={{ __html: text }}
              />
            </a>
          );
        })}
      </div>
    </section>
  );
};

export default ImageTextGrid;
